import {getNationalIdLabel} from 'Utility/commons/countries/nationalIdLabels';
import {validUS, validCA, validUK} from 'Utility/commons/countries/codes';

export const tinMask = (countryCode: string): any => {
  if (validUS(countryCode)) {
    return '000-00-0000';
  } else if (validCA(countryCode)) {
    return '000-000-000';
  } else if (validUK(countryCode)) {
    return 'aa-000000-a';
  } else {
    return /^[a-zA-Z0-9]*$/;
  }
};

export const businessNumberMask = (countryCode: string): any => {
  if (validUS(countryCode)) {
    return '00-0000000';
  } else if (validCA(countryCode)) {
    return '000000000';
  } else {
    return /^[a-zA-Z0-9]*$/;
  }
};

export const tinLabel = (countryCode: string): string => {
  if (validUS(countryCode)) {
    countryCode = 'US';
  }
  return getNationalIdLabel(countryCode, true);
};

export const tinPlaceholder = (countryCode: string): string => {
  return `${tinLabel(countryCode)} *`;
};
